const HandledErrors = {
  UNSUPPORTED_APP_VERSION: {
    code: "UNSUPPORTED_APP_VERSION",
    httpStatus: 426,
    message: "An update is required",
  },
  PRO_PLAN_REQUIRED: {
    code: "PRO_PLAN_REQUIRED",
    httpStatus: 402, // 402 Payment Required
    message: "Pro plan is required.",
  },
  APPLE_SIGN_IN_RESET_REQUIRED: {
    code: "APPLE_SIGN_IN_RESET_REQUIRED",
    httpStatus: 403,
    message: "Apple Sign In needs to be reset for this app.",
  },
  USER_NOT_FOUND: {
    code: "USER_NOT_FOUND",
    httpStatus: 404,
    message: "This user could not be found.",
  },
  EMAIL_TAKEN: {
    code: "EMAIL_TAKEN",
    httpStatus: 409,
    message: "This email is already being used by another account.",
  },
  COLLABORATIVE_SPACE_CANNOT_DELETE_USER: {
    code: "COLLABORATIVE_SPACE_CANNOT_DELETE_USER",
    httpStatus: 400,
    message:
      "One or more of the spaces you own are collaborative. Please delete them first.",
  },
} satisfies Record<string, HandledErrorJson>;

export type HandledErrorJson = {
  code: string;
  message: string;
  httpStatus: number;
};

export function isHandledErrorJson(obj: unknown): obj is HandledErrorJson {
  return Boolean(
    obj &&
      typeof obj === "object" &&
      "code" in obj &&
      "message" in obj &&
      "httpStatus" in obj
  );
}

// Classes are better suited for errors as we can do "instanceof" checks
// Generally speaking, TodayErrors are what we'd consider as client-handled errors
export class HandledError extends Error {
  code: string;

  constructor(code: string, message: string) {
    super(message);
    this.code = code;
  }

  static fromHandledErrorJson(
    jsonError: { code: string; message: string } | null | undefined
  ): HandledError | null {
    if (!jsonError || !jsonError.code || !jsonError.message) return null;
    return new HandledError(jsonError.code, jsonError.message);
  }

  toJSON() {
    return {
      code: this.code,
      message: this.message,
    };
  }

  isError({ code }: { code: string }) {
    return this.code === code;
  }
}

export default HandledErrors;
